import { forwardRef, Ref } from 'react';

import { useChannels } from '@mint-lib/hooks';
import styled from '@mint-lib/styled';

import { Box, DraggableItem, Icon } from '@myn/mui';
import { SVG } from '@myn/resources';

export type Props = {
  row: any;
  withoutIcon?: boolean;
  isDragged?: boolean;
  inverted?: boolean;
  isChannelRow?: boolean;
  type?: string;
  onDoubleClick?: () => void;
};

export const ChannelPlatformRow = forwardRef(
  (
    {
      row,
      withoutIcon,
      isDragged,
      inverted,
      isChannelRow,
      onDoubleClick,
    }: Props,
    ref: Ref<HTMLDivElement>,
  ) => {
    const channelsMeta = useChannels();
    const isRowInverted = inverted || row.isDisabled;
    const iconOpacity = isRowInverted ? 0.2 : 1;

    const StartAdornment = isChannelRow ? (
      <Icon
        component={channelsMeta[row.name]?.icon ?? 'Settings'}
        sx={{ opacity: iconOpacity }}
      />
    ) : (
      <Logo
        src={row.logo || SVG.customPlatform}
        alt={row.logo}
        sx={{ opacity: iconOpacity }}
      />
    );

    return (
      <Box ref={ref}>
        <DraggableItem
          text={row.label}
          isDragged={isDragged}
          onDoubleClick={onDoubleClick}
          startAdornment={withoutIcon ? undefined : StartAdornment}
          disabled={isRowInverted}
        />
      </Box>
    );
  },
);

const Logo = styled('img')`
  width: 16px;
  height: 16px;
`;
